<template>
	<div class="appView">
		<Sidebar></Sidebar>
		<div
			id="overview-page"
			class="contentView overviewView categoriesSubview"
			@click="isSort = false"
		>
			<loading :active.sync="globalLoading" :is-full-page="fullPage"></loading>
			<div class="navBar">
				<Hamburger class="hamburger" />
				<div class="title">Overview</div>

				<div class="segmentedBar index0">
					<div
						class="segment"
						:class="attributeType == 'category' ? 'selected' : ''"
						@click="segmentChange('category')"
					>
						<div class="title">Categories</div>
					</div>
					<div class="separator separator1"></div>
					<div
						class="segment"
						:class="attributeType == 'vendor' ? 'selected' : ''"
						@click="segmentChange('vendor')"
					>
						<div class="title">Vendors</div>
					</div>
					<div class="separator separator2"></div>
					<div
						class="segment"
						:class="attributeType == 'project' ? 'selected' : ''"
						@click="segmentChange('project')"
					>
						<div class="title">Projects</div>
					</div>
				</div>

				<div class="actions">
					<div class="action datePicker" @click.stop @click="isSort = !isSort">
						<div class="icon"></div>
						<div class="title">
							{{
								periodType == "alltime"
									? "All Time"
									: periodType == "monthly"
									? "Month"
									: "Year"
							}}
						</div>
						<div class="expand"></div>
					</div>
				</div>
				<div class="pickerView sortPicker" v-if="isSort" @click.stop>
					<div class="title">Sort Expenses</div>
					<div class="block" :class="periodType == 'monthly' ? 'selected' : ''">
						<div class="title" @click="calSort('monthly')">Month</div>
					</div>
					<div class="block" :class="periodType == 'yearly' ? 'selected' : ''">
						<div class="title" @click="calSort('yearly')">Year</div>
					</div>
					<div class="block" :class="periodType == 'alltime' ? 'selected' : ''">
						<div class="title" @click="calSort('alltime')">All Time</div>
					</div>
				</div>

				<div class="headerSeparator"></div>
			</div>

			<div class="overviewHeader">
				<div class="titleBar">
					<div class="details">
						<div class="date">
							<span v-if="periodType == 'monthly'"
								>{{ getMonthName(selectedMonth) }}, {{ selectedYear }}</span
							>
							<span v-if="periodType == 'yearly'">{{ selectedYear }} </span>
						</div>
						<div class="value" v-if="dataList.total_amount">
							{{ toFormatedCurrency((dataList.total_amount * 100) / 100, "$") }}
						</div>
					</div>

					<div v-if="periodType !== 'alltime'" class="actions">
						<div
							class="action previous"
							:class="
								periodType == 'monthly' && selectedMonth == 0 ? 'disabled' : ''
							"
							@click="calPrev()"
						>
							<div class="icon"></div>
						</div>
						<div
							class="action next"
							:class="
								(periodType == 'monthly' && selectedMonth == 11) ||
								(periodType == 'yearly' && selectedYear == currentYear)
									? 'disabled'
									: ''
							"
							@click="calNex()"
						>
							<div class="icon"></div>
						</div>
					</div>
				</div>

				<div
					v-if="
						periodType != 'monthly' &&
							!globalLoading &&
							dataList['periods'].length > 0
					"
					id="overview-graph"
					class="graph"
				>
					<div
						v-for="(data, key) in dataList['periods']"
						class="graphItem"
						:key="key"
					>
						<div class="dayTotal">
							<div class="amount">
								{{ toFormatedCurrency(data.total_amount, "$") }}
							</div>
						</div>
						<div class="bar">
							<div
								v-for="(attribute, attrKey) in data['attributes']"
								:key="attrKey"
								class="barFill"
								:class="'category' + attribute.icon"
								:style="
									`${
										attributeType == 'vendor' || attributeType == 'project'
											? 'background: ' + attribute.vendor.Color
											: ''
									}; height: ${
										attribute.progress
									}%; position: absolute; bottom: 0;`
								"
							></div>
						</div>
						<div class="day">{{ data.month_name }}</div>
					</div>
				</div>

				<div class="separator"></div>
			</div>

			<div
				class="contentPlaceholder"
				v-if="
					!globalLoading &&
						(dataList['periods'].length < 1 ||
							dataList['attributes'].length < 1)
				"
			>
				<div class="placeholderWrapper">
					<h6>No Expenses</h6>
					<p>
						You don't have any expenses
						<span v-if="periodType !== 'alltime'"
							>in
							<span v-if="periodType === 'monthly'"
								>{{ getMonthName(selectedMonth) }},</span
							>
							{{ selectedYear }}</span
						>
					</p>
				</div>
			</div>

			<div
				class="breakdownList tableView"
				v-if="!globalLoading && dataList['attributes'].length > 0"
			>
				<div class="tableSection">
					<div class="progressBarsWrapper">
						<section
							class="ProgressBarContainer"
							v-for="(attribute, attrKey) in dataList['attributes']"
							:key="attrKey"
							:class="'category' + attribute.icon"
						>
							<div class="content">
								<div class="icon" v-if="attributeType == 'category'"></div>
								<span class="title">{{ attribute.name }}</span>
								<span class="amount">
									{{ toFormatedCurrency((attribute.amount * 100) / 100, "$") }}
								</span>
							</div>
							<div
								class="progressBar"
								:style="{
									inset: `0 ${100 - attribute.progress}% 0 0`,
									backgroundColor:
										attributeType == 'vendor' || attributeType == 'project'
											? attribute.vendor.Color
											: null
								}"
							>
								<div class="content">
									<div class="icon" v-if="attributeType == 'category'"></div>
									<span class="title"> {{ attribute.name }}</span>
									<span class="amount">
										{{
											toFormatedCurrency((attribute.amount * 100) / 100, "$")
										}}
									</span>
								</div>
							</div>
							<div class="contentPlaceholderToGetCorrectHeight">
								<div class="content">
									<div class="icon" v-if="attributeType == 'category'"></div>
									<span class="title">{{ attribute.name }}</span>
									<span class="amount">
										{{
											toFormatedCurrency((attribute.amount * 100) / 100, "$")
										}}
									</span>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Sidebar from "../components/Sidebar.vue";
import { getUserId } from "../utils/auth";
import moment from "moment";
import Loading from "vue-loading-overlay";
window._ = require("lodash");
import Hamburger from "../components/Hamburger.vue";

export default {
	data() {
		return {
			fullPage: false,
			userId: getUserId(),
			isSort: false,
			attributeType: "category",
			periodType: "monthly",
			dataList: {
				attributes: [],
				periods: [],
				total_amount: 0
			},
			selectedMonth: moment().month(),
			selectedYear: moment().year(),
			period: moment().format("YYYYMM"),
			rowBarWidth: null,
			latestYear: null,
			latestMonth: null,
			latestMonthPeriod: null
		};
	},
	components: {
		Sidebar,
		Loading,
		Hamburger
	},
	mounted() {
		this.getLatestPeriod();
	},
	methods: {
		async getLatestPeriod(type = "alltime", year = "") {
			this.globalLoading = true;
			this.$axios
				.get(
					"/statistics?user_id=" +
						this.userId +
						"&attribute_type=" +
						this.attributeType +
						"&period_type=" +
						type +
						"&period=" +
						year,
					{ crossdomain: true }
				)
				.then(
					({ data }) => {
						if (data.data.periods.length > 0) {
							const maxPeriodValue = _.maxBy(data.data.periods, "period");
							if (!this.latestYear) {
								this.latestYear = maxPeriodValue.period;
								if (this.latestYear) {
									this.selectedYear = parseInt(this.latestYear);
									this.getLatestPeriod(
										(type = "yearly"),
										(year = maxPeriodValue.period)
									);
								}
							} else {
								if (maxPeriodValue) {
									this.latestMonthPeriod = maxPeriodValue.period;
									const latestMonth = this.latestMonthPeriod.toString();
									this.selectedMonth = this.latestMonth =
										+latestMonth.slice(-2) - 1;
									this.period = maxPeriodValue.period;
									this.getOverview();
								}
							}
						} else {
							this.getOverview();
						}
					},
					e => {}
				)
				.finally(() => {});
		},
		async calSort(period_type) {
			this.periodType = period_type;
			if (period_type === "monthly") {
				this.selectedMonth = this.latestMonth
					? this.latestMonth
					: moment().month();
				this.period = this.latestMonthPeriod
					? this.latestMonthPeriod
					: moment().format("YYYYMM");
			} else if (period_type === "yearly") {
				this.selectedYear = parseInt(this.latestYear);
				this.period = this.latestYear;
			} else {
				this.period = "";
			}
			this.isSort = !this.isSort;
			this.getOverview();
		},
		segmentChange(segment) {
			this.attributeType = segment;
			this.getOverview();
		},
		getMonthName(monthNumber) {
			return moment()
				.month(monthNumber)
				.format("MMMM");
		},
		calNex() {
			if (this.periodType == "monthly") {
				if (this.selectedMonth < 11) {
					this.selectedMonth = this.selectedMonth + 1;
					this.period =
						this.selectedYear + "" + ("0" + (this.selectedMonth + 1)).slice(-2);
				}
			} else if (this.periodType == "yearly") {
				if (this.selectedYear < moment().year()) {
					this.selectedYear = parseInt(this.selectedYear) + 1;
					this.period = this.selectedYear;
				}
			}
			this.getOverview();
		},
		calPrev() {
			if (this.periodType == "monthly") {
				if (this.selectedMonth > 0) {
					this.selectedMonth = this.selectedMonth - 1;
					this.period =
						this.selectedYear + "" + ("0" + (this.selectedMonth + 1)).slice(-2);
				}
			} else if (this.periodType == "yearly") {
				this.selectedYear = parseInt(this.selectedYear) - 1;
				this.period = this.selectedYear;
			}
			this.getOverview();
		},
		async getOverview() {
			try {
				this.dataList = {
					attributes: [],
					periods: [],
					total_amount: 0
				};
				var self = this;
				this.globalLoading = true;
				const attributeList = await this.fetchAttributes(this.userId);
				var num = 0;
				attributeList[this.attributeType].forEach(project => {
					project.ColorTranslucent = self.projectBackgroundColors[num];
					project.Color = self.projectColors[num];
					num++;
					if (num == 10) num = 0;
				});

				const { data } = await this.$axios.get(
					"/statistics?user_id=" +
						this.userId +
						"&attribute_type=" +
						this.attributeType +
						"&period_type=" +
						this.periodType +
						"&period=" +
						this.period,
					{ crossdomain: true }
				);
				this.dataList = data.data;

				let sumTotal = 0;
				this.dataList["attributes"].forEach(attribute => {
					sumTotal += Math.abs(attribute.amount);

					attribute["icon"] = self.getCategoryIcon(attribute["name"]);
					if (this.attributeType == "category") {
						attribute["vendor"] = self.findVal(
							attributeList.category,
							attribute.name
						);
					}

					if (this.attributeType == "vendor") {
						attribute["vendor"] = self.findVal(
							attributeList.vendor,
							attribute.name
						);
					}

					if (this.attributeType == "project") {
						attribute["vendor"] = self.findVal(
							attributeList.project,
							attribute.name
						);
					}
				});

				// need to wait for the above loop to finish getting sum total before calculating the individual percentages
				this.dataList.attributes.forEach(attribute => {
					attribute["progress"] = (Math.abs(attribute.amount) * 100) / sumTotal;
				});

				var attrSize = "";
				this.dataList["periods"].forEach(period => {
					attrSize = _.size(period["attributes"]);
					if (this.periodType == "yearly") {
						period["month_name"] = this.getMonthName(
							(period["period"] % 100) - 1
						);
					} else if (this.periodType == "alltime") {
						period["month_name"] = period["period"];
					}
					period["attributes"].forEach(attribute => {
						attribute.progress = (Math.abs(attribute.amount) * 100) / sumTotal;
						attribute["icon"] = self.getCategoryIcon(attribute["name"]);
						attribute["zIndex"] = attrSize;

						if (self.attributeType == "category") {
							attribute["vendor"] = self.findVal(
								attributeList.category,
								attribute.name
							);
						}

						if (self.attributeType == "vendor") {
							attribute["vendor"] = self.findVal(
								attributeList.vendor,
								attribute.name
							);
						}

						if (self.attributeType == "project") {
							attribute["vendor"] = self.findVal(
								attributeList.project,
								attribute.name
							);
						}
						attrSize--;
					});
					period.attributes.sort((a, b) => b.progress - a.progress);
				});
			} catch (error) {
				return error;
			} finally {
				this.globalLoading = false;
				var rowBar = document.getElementsByClassName("rowBar");
				if (rowBar.length > 0) {
					this.rowBarWidth = rowBar[0].offsetWidth;
				}
			}
		},
		calcluateVerticalBarSpacing(progressPercent, index) {
			var result = `height: ${progressPercent}%; position: absolute; bottom: 0`;
			return result;
		},
		calcluateHorizonBarSpacing(progressPercent) {
			var result = "width:" + progressPercent + "%;";
			return result;
		}
	}
};
</script>
